/*
 * @Author       : LQ
 * @Description  :
 * @version      : 1.0
 * @Date         : 2021-08-20 16:44:21
 * @LastAuthor   : LQ
 * @lastTime     : 2021-08-20 16:47:24
 * @FilePath     : /u-view2.0/uview-ui/libs/config/props/album.js
 */
export default {
    // album 组件
    album: {
        urls: () => [],
        keyName: '',
        singleSize: 180,
        multipleSize: 70,
        space: 6,
        singleMode: 'scaleToFill',
        multipleMode: 'aspectFill',
        maxCount: 9,
        previewFullImage: true,
        rowCount: 3,
        showMore: true
    }
}
